<template>
  <div class="Hero">
    <div class="container">
      <Navbar />
      <div class="HeroContent">
        <h1>
          Are you ready<br />
          for a <span>tech interview?</span>
        </h1>
        <h3>
          Full-stack, Data structures &amp; Design patterns interview questions
          answered
        </h3>
        <button @click="handleClick" class="HeroBtn btn">
          See all questions
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar';
import smoothscroll from 'smoothscroll-polyfill';

export default {
  name: 'Hero',
  components: {
    Navbar,
  },
  mounted() {
    smoothscroll.polyfill();
  },
  methods: {
    handleClick() {
      const position = document.querySelector('.Hero').offsetHeight - 140;
      window.scrollTo({ top: position, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.Hero {
  height: 870px;
  background: url('../assets/img/hero_bg.svg') no-repeat top center;
  background-color: $color-background-dark;
  .HeroContent {
    margin: 0 auto;
    padding: 100px 0 150px;
    text-align: center;
    h1 {
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 90px;
      color: $color-white;
      span {
        color: $color-pink;
        background: -webkit-linear-gradient(#5c86ee, #e58aeb);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    h3 {
      margin: 0 auto 65px;
      font-weight: 400;
      font-size: 21px;
      color: $color-white;
      line-height: 1.5;
    }
    .HeroBtn {
      border: 1px solid $color-white;
      background: none;
      color: $color-white;
      transition: all 0.2s ease-out;
      &:hover {
        color: $color-purple;
        background: $color-white;
        transition: all 0.2s ease-out;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .Hero {
    .HeroContent {
      h1 {
        font-size: 65px;
      }
    }
  }
}

@media screen and (max-width: 650px) {
  .Hero {
    height: 750px;
    .HeroContent {
      padding: 100px 0 100px;
      h1 {
        margin: 0 auto 20px;
        font-size: 32px;
      }
      h3 {
        font-size: 15px;
        margin-bottom: 30px;
      }
      .HeroBtn {
        width: 200px;
        font-size: 15px;
      }
    }
  }
}
</style>
